import deepEquals from 'Lib/Object/deepEquals';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { Label } from '../../Core';
import { EquipmentStatus } from '../EquipmentStatus';
import './EquipmentLabel.scss';

export interface IEquipmentLabelProps {
  // label props
  label?: string;
  emph?: boolean;
  id?: string;
  // calibration icon props
  value?: any;
  equipmentType: string;
  status?: any;
  statusDate?: any;
  importAction?: any;
  importedCalibration?: any;
  importedAdditionalData?: any;
  importModel?: any;
  importing?: boolean;
}

// Label component to be used for equipment input types
// Includes label text and calibration status icon
const EquipmentLabel: React.FC<IEquipmentLabelProps> = ({
  label,
  emph,
  id,
  equipmentType,
  status: fixedStatus,
  statusDate = moment().format('YYYY-MM-DD'),
  importAction,
  importedCalibration,
  importedAdditionalData,
  importModel,
  importing,
  value,
}) => {
  const status = useSelector(
    (state) => fixedStatus ?? (id && (state.equipment.equipmentData as any)[id]?.data?.Status),
    deepEquals
  );
  const fetchedEquipmentData = useSelector(
    (state) => id && (state.equipment.equipmentData as any)[id]?.data,
    deepEquals
  );

  return (
    <div className="EquipmentLabel">
      <div className="EquipmentLabel-Label">
        <Label emph={emph} htmlFor={id}>
          {label}
        </Label>
      </div>
      <div className="EquipmentLabel-EquipmentStatus">
        <EquipmentStatus
          equipment={fetchedEquipmentData ?? value}
          equipmentType={equipmentType}
          status={status}
          statusDate={statusDate}
          importAction={importAction}
          importedCalibration={importedCalibration}
          importedAdditionalData={importedAdditionalData}
          importModel={importModel}
          importing={importing}
          noPadding
        />
      </div>
    </div>
  );
};

export { EquipmentLabel };
